import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import { useInView } from "../../../../hooks/index.js";
import { observedThresholds } from "../utils/observedThresholds.js";
import { Item } from "./Item.js";
const Observe = forwardRef((props, ref) => {
  const { index, testid, children, viewport, onChange, threshold, forceVisible, showChildrenOutsideViewport } = props;
  const { ref: observerRef, entry } = useInView({
    onChange,
    root: viewport,
    threshold: observedThresholds
  });
  const setRef = useCallback(
    (node) => {
      observerRef(node);
      if (ref) {
        if (typeof ref === "function") {
          ref(node ?? null);
        } else {
          ref.current = node ?? null;
        }
      }
    },
    [observerRef, ref]
  );
  const ratio = entry?.intersectionRatio ?? 0;
  const outOfView = ratio < threshold;
  const show = forceVisible || !outOfView;
  return /* @__PURE__ */ jsx(
    Item,
    {
      className: "truncate-list-observe",
      "data-testid": testid,
      style: {
        visibility: showChildrenOutsideViewport ? "visible" : show ? "visible" : "hidden"
      },
      children: /* @__PURE__ */ jsx("div", { "data-index": index, ref: setRef, children })
    }
  );
});
export {
  Observe
};
//# sourceMappingURL=Observe.js.map
